import React from "react";
import L, { LatLngExpression, PathOptions } from "leaflet";
import { PolyLine } from "../../data/layers";
import { getBikeWayStyle } from "../../services/bicycle_ways";

function buildWayDescription(way: PolyLine) {
  const tags = way?.tags || {};
  const style = way.renderStyle || getBikeWayStyle(tags);
  const summary: string[] = [];

  if (style?.className) {
    summary.push(`class: ${style.className}`);
  }

  if (style?.surfaceClass) {
    summary.push(`surfaceClass: ${style.surfaceClass}`);
  }

  Object.entries(tags).forEach(([key, value]) => {
    summary.push(`${key}: ${value}`);
  });

  return summary.join("<br />\n");
}

export function getAciveWays(
  layerWaysGroupRef: React.MutableRefObject<L.LayerGroup<any>>,
  activeWays: PolyLine[] | null | undefined,
  bikeWayVisibility?: Record<string, boolean>
) {
  if (!layerWaysGroupRef.current) {
    return;
  }

  layerWaysGroupRef.current.clearLayers();

  const sortedWays = [...(activeWays || [])].sort((left, right) => {
    const leftZ = left.renderStyle?.zIndex || 0;
    const rightZ = right.renderStyle?.zIndex || 0;
    return leftZ - rightZ;
  });

  sortedWays.forEach((way) => {
    if (way.bikeClass && bikeWayVisibility && bikeWayVisibility[way.bikeClass] === false) {
      return;
    }

    if (!Array.isArray(way?.nodes) || way.nodes.length < 2) {
      return;
    }

    const validNodes = way.nodes.filter((node) => node?.lat !== undefined && node?.lon !== undefined);
    if (validNodes.length < 2) {
      return;
    }

    const line: LatLngExpression[] = validNodes.map((node) => [node.lat, node.lon]);
    const style = way.renderStyle || getBikeWayStyle(way.tags || {});

    if (!style) {
      return;
    }

    const pathStyle: PathOptions = {
      color: style.color,
      weight: style.width,
      opacity: style.opacity,
      dashArray: style.dasharray || undefined,
      lineCap: "round",
      lineJoin: "round",
    };

    const description = buildWayDescription(way);
    const mapLine = L.polyline(line, pathStyle);

    if (description) {
      mapLine.bindPopup(description);
      // Temporarily hide road tooltips; point tooltips remain enabled elsewhere.
      // mapLine.bindTooltip(description);
    }

    mapLine.addTo(layerWaysGroupRef.current);

    if (style.innerColor && style.innerWidth) {
      L.polyline(line, {
        color: style.innerColor,
        weight: style.innerWidth,
        opacity: style.opacity,
        dashArray: style.innerDasharray || undefined,
        lineCap: "round",
        lineJoin: "round",
        interactive: false,
      }).addTo(layerWaysGroupRef.current);
    }
  });
}
